<template lang="html">
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div class="table-responsive-sm" style="padding:0px">
            <table class="table b-table table-striped" style="margin-bottom:0px">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <!-- <td width="80" style="background-color:#f1f1f1">
                        <label class="col-form-label">아이디</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="12"><b-form-input id="basicText" type="text" v-model="userQueryParams.user_id" v-on:keyup="$event.keyCode === 13 ? findUserSearchList() : ''" placeholder="아이디를 입력해주세요."></b-form-input></b-col>
                        </b-row>
                      </td> -->
                      <td width="80" style="background-color:#f1f1f1">
                        <label class="col-form-label">검색어</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="12"><b-form-input id="basicText" type="text" v-model="userQueryParams.name" v-on:keyup="$event.keyCode === 13 ? findUserSearchList() : ''" placeholder="회원명을 입력해주세요."></b-form-input></b-col>
                        </b-row>
                      </td>
                  </tr>
                </tbody>
            </table>
            <div style="float:right; padding:5px">
              <b-button type="submit" variant="success" v-on:click="findUserSearchList()"><i class="fa fa-dot-circle-o"></i> 검색</b-button>
            </div>
          </div>
        </b-card>

        <b-card>
          <b-row>
            <b-col sm="12">
              <div class="text-center loadingbar" style="margin:220px 0 230px 0">
                <div style="width:200px; margin:0 auto; vertical-align:middle">
                  <b-spinner label="Large Spinner" style="vertical-align:middle"></b-spinner>
                  <span style="vertical-align:middle; padding:5px; font-weight:blod; font-size:20px">Loading...</span>
                </div>
              </div>
            </b-col>
            <b-col sm="12" class="tabledisplay">
              <b-row>
                <b-col sm="2">
                  <span class="pr-"><strong>총 {{items.length}}건</strong></span>
                </b-col>
                <b-col sm="2"></b-col>
                <b-col sm="5"></b-col>
                <b-col md="3">
                  <b-form-group label-cols-sm="5" label="" class="mb-0">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" class="pt-sm-1 tabledisplay" style="padding:0px">
              <b-row>
                <b-col sm="1"></b-col>
                <b-col sm="12">
                  <b-table
                    striped
                    hover
                    :fields="fieldItems"
                    :items="items"
                    :busy="items == 0"
                    :current-page="currentPage"
                    :per-page="perPage"
                    >
                    <div slot="table-busy" class="text-center my-2">
                      <strong>데이터가 없습니다.</strong>
                    </div>
                    <template slot="custom_button" slot-scope="data">
                      <div style="margin:0 auto">
                        <b-button v-if="(data.item.active_cnt == -1 || data.item.active_cnt == 0) && data.item.order_ing_cnt <= 0" variant="info" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; height:30px; border:1px solid #187c9f; font-size:15px" href="javascript:void(0)" v-on:click="userResultData(data.item, 'newauth')"><h6 style="font-weight:bold"><i class="fa fa-hand-pointer-o"></i> 적용</h6></b-button>
                        <b-button v-if="(data.item.active_cnt == -1 || data.item.active_cnt == 0) && data.item.order_ing_cnt > 0" :disabled="true" style="color:#ffffff; border-radius:5px; cursor:default; width:100%; height:30px; background-color:#0f596f; border:1px solid #020a20; font-size:15px"><h6 style="font-weight:bold"><i class="fa fa-gear"></i> 주문결제중</h6></b-button>
                        <b-button v-if="data.item.active_cnt > 0 && data.item.active_cnt < 2" variant="danger" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; height:30px; border:1px solid #b50403; font-size:15px" href="javascript:void(0)" v-on:click="userResultData(data.item, 'addauth')"><h6 style="font-weight:bold"><i class="fa fa-user-plus"></i> 연장</h6></b-button>
                        <b-button v-if="data.item.active_cnt >= 2" :disabled="true" style="color:#ffffff; border-radius:5px; cursor:default; width:100%; height:30px; border:1px solid #75757d; font-size:15px"><h6 style="font-weight:bold"><i class="fa fa-close"></i> 불가(연장된계정)</h6></b-button>
                      </div>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" class="pt-sm-1 tabledisplay">
              <b-row class="pb-sm-2">
                <b-col sm="1"></b-col>
                <b-col sm="12" class="my-1">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="listRows"
                    :per-page="perPage"
                    align="center"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    userInfoOptions: {
      user_id: '',
      user_name: '',
      company_name: '',
      position: '',
    },
    userFormModal: null,
  },
  data(){
    return {
      // userQueryParams: {},
      userQueryParams: {
        name: '',
        ageRange: [],
        letter_yn: [],
        gender: [],
        grade: [],
        industry_key: [],
        authority: [],
        user_status: [],
        endDate: '',
        startDate: '',
        employee:[],
        downloadYn:'',
      },
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 30, 50, 100],
      fieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'tdStyle': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'user_id': {
          'label': '아이디',
          'class': 'text-center',
          'tdClass': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'name': {
          'label': '회원명',
          'class': 'text-center',
          'tdClass': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'reg_date': {
          'label': '가입일',
          'class': 'text-center',
          'tdClass': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'company_name': {
          'label': '기업명',
          'class': 'text-center',
          'tdClass': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        'custom_button': {
          'label': '적용',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }],
      items: [],
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  mounted: function() {
    $(".loadingbar").hide();
    $(".tabledisplay").show();
    var self = this;
    // var self = this;
    // self.findUserSearchList();
  },
  watch: {
    userFormModal (newVal, oldVal) {
      var self = this;
      if(newVal){
        // self.userQueryParams = {};
        self.findUserSearchList();
      }
      // self.optRowsData = [];
      // self.pkgRowsData = [];
      // self.$refs.optTable.refresh();
      // self.$refs.pkgTable.refresh();
      // console.log(self.reportOptions);
      // if(self.formModal){
      //   self.reportOptions.optItems.forEach(function (el, idx, arr){
      //     el.rnum = (idx+1);
      //   });
      // }
    },
  },
  methods:{
    // 메소드명 : findUserSearchList()
    // ### 유저 검색 조회 ###
    // 유저를 T_DR_USER DB테이블에서 조회한다.
    //
    // 최초작성 : 2019.09.16
    // 파라미터 :
    //  - Object => userQueryParams(user_id,user_name)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜     작성자   수정내용
    // 2019.09.16  황경현   최초작성
    // *************************
    findUserSearchList() {
      $(".loadingbar").show();
      $(".tabledisplay").hide();
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.userQueryParams));
      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/select/reportUserList?access_token=' + token, data, null)
      .then((result) => {
        console.log(result.data);
        self.items = result.data.resultList;
        var itemCnt = result.data.resultListCount;
        self.items.forEach(function (el, idx, arr){
          el.rnum = itemCnt - (idx);
        });
        $(".loadingbar").hide();
        $(".tabledisplay").show();
      })
    },
    userResultData(userdata, type) {
      var data = {
        userdata: userdata,
        type: type,
      };
      this.$emit('childs-event', data);
    },
  },
}
</script>


<style scoped>
.user-vmiddle {vertical-align: middle;}
</style>



// WEBPACK FOOTER //
// src/views/order/UserProductModal.vue